"use client"

import styled, { css } from "styled-components"

import { Button as BaseButton } from "@/components/Button"
import { BaseParagraph } from "@/components/Paragraph/styled"

export const Button = styled(BaseButton)`
  ${({ theme, primary }) => {
    const { colors, spaces, borders } = theme
    return css`
      gap: ${spaces.large};
      border-radius: ${borders.radius.extraSmall};
      ${getPaddingStyles};
      cursor: ${primary && "default"};

      :hover,
      :active,
      :target {
        background-color: ${primary && colors.primary.bg};
      }

      svg:hover {
        background-color: transparent;
      }
    `
  }}
`

const getPaddingStyles = ({ theme, secondary, $additional, $sideNavOpen }) => {
  const { spaces } = theme
  const { minHeight } = theme.widgets.button.sizes
  if (secondary) {
    return css`
      padding: ${spaces.small};
    `
  }
  if ($sideNavOpen) {
    return css`
      padding: ${!$additional && spaces.small} ${$additional ? spaces.normalToMedium : spaces.large};
      min-height: ${!$additional && minHeight};
    `
  }
  return css`
    padding: ${$additional ? spaces.normalToMedium : spaces.large};
  `
}

export const TextSection = styled.div`
  ${({ theme, $additional }) => {
    const { spaces } = theme
    const { weight, size } = theme.fonts
    return css`
      display: flex;
      flex-direction: column;
      gap: ${!$additional && spaces.tiny};
      padding-right: ${$additional && spaces.large};
      font-weight: ${weight.normal};

      & > ${BaseParagraph}:nth-child(2) {
        line-height: ${size.smallParagraph};
      }

      &:hover,
      p:hover {
        background-color: transparent;
      }
    `
  }}
`
